//�����`�F�b�N
let validLength = (min, max, value) => {
  if( min >= 1 && value == null ) return false
  if( min == 0 && value == null ) return true
    
  if( value.length >= min && value.length <= max ){
    return true
  }
  return false
}

//���l�����`�F�b�N
let validInteger = (minLength, maxLength, value) => {
    var pattern = '^[0-9]{' + minLength + ',' + maxLength + '}$'; 
    console.log( pattern )
    return value.match( pattern )
}

let validEmail = ( value ) => {
    var pattern = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/;
    
    return pattern.test( value )
}


//�K�{�`�F�b�N
let validRequire = ( value) => {
    if( value == null || value.length == 0 ) return false
    return true
}

//yyyy/MM�`�F�b�N
let validYearMonth = ( value ) =>{

    value += "/01"
    return validDate( value );
}

//yyyy/MM/dd�`�F�b�N
let validDate = ( value ) =>{
    if(!value.match(/^\d{4}\/\d{2}\/\d{2}$/)){
        return false;
    }
    var y = value.split("/")[0];
    var m = value.split("/")[1] - 1;
    var d = value.split("/")[2];
    var date = new Date(y,m,d);
    if(date.getFullYear() != y || date.getMonth() != m || date.getDate() != d){
        return false;
    }
    return true;
}


export{ validLength, validInteger, validRequire, validYearMonth, validDate, validEmail }